module.exports = __webpack_public_path__ + "shutterstock_352907537.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/shutterstock_352907537.jpg
// module id = 272
// module chunks = 0